export const SdwanMobileSecond = () => {
    return (
        <div className="pt-[46px] px-[20px]">
            <div className="flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">光年无界 企业出海网络解决方案</div></div>
            <div className="flex justify-center"><div className="text-[8px] mt-[6px] font-regular text-[rgba(51,51,51,1)]">让企业出海网络搭建变得更简单</div></div>


            <div className="mt-[15px] flex flex-col bg-gradient-to-br from-[#D7E6FE] to-[#FFFFFF] rounded-[20px] border border-[#D9DEFF] p-[16px] px-[27px] flex relative">
                <div>
                    <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[14px] text-[#003366]">
                        全球SD-WAN网络加速服务
                    </div>
                    <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[10px] text-[rgba(0,51,102,0.6)] mt-[5px]">
                        通过光年自研K-WAN加速引擎在全球部署节点组建专用骨干网络，为企业提供安全、合规、稳定的全球互联网服务
                    </div>
                    <Item content="线路采用三大运营商国际专线组建，安全合规可靠" />
                    <Item content="采用自研K-WAN加速引擎，极简配置，多种部署模式" />
                    <Item content="协助企业构建高性价比的专属全场景网络连接方案" />
                    <Item content="支持跨境电商、海外直播、外贸企业、企业跨国组网多场景使用" />
                    <Item content="低延迟、丢包少，支持企业定制" />
                </div>
                <div className="flex gap-[15px] items-center justify-center">
                    <img className="w-[186px] h-[137px] " src="/imgs/sdwan/5.png" />
                    <div className="w-[85px] h-[27px] bg-gradient-to-br from-[#5FD7FF] to-[#0151FF] rounded-[4px]  flex items-center justify-center">
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[11px] text-[#FFFFFF]">
                            查看详情
                        </div>
                    </div>
                </div>
            </div>




            <div className="mt-[15px] flex flex-col bg-gradient-to-br from-[#D7E6FE] to-[#FFFFFF] rounded-[20px] border border-[#D9DEFF] p-[16px] px-[27px] flex relative">
                <div>
                    <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[14px] text-[#003366]">
                        全球直播专线/TK直播养号
                    </div>
                    <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[10px] text-[rgba(0,51,102,0.6)] mt-[5px]">
                        提供TikTok、Shopee等常用海外平台直播专线，0卡顿、不封号，助力TikTok养号/矩阵/直播等多类业务场景
                    </div>
                    <Item content="使用自研加速引擎，保证直播数据流畅传输" />
                    <Item content="经得起三方检测的独享原生家庭IP、确保IP纯净度" />
                    <Item content="采用运营商专线互联，可直签确保合规性" />
                    <Item content="支持多账号、多IP同时直播" />
                    <Item content="支持软件/硬件接入网络，灵活使用更方便" />
                </div>
                <div className="flex gap-[15px] items-center justify-center">
                    <img className="w-[173px] h-[151px] " src="/imgs/sdwan/6.png" />
                    <div className="w-[85px] h-[27px] bg-gradient-to-br from-[#5FD7FF] to-[#0151FF] rounded-[4px]  flex items-center justify-center">
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[11px] text-[#FFFFFF]">
                            查看详情
                        </div>

                    </div>
                </div>

            </div>

            <div className="flex w-full  gap-[7px] mt-[10px]">
                <div
                    className="flex-1 bg-blue-500 bg-gradient-to-b from-[#D8E7FE] to-[#FFFFFF]
        rounded-[20px] border border-[#DDE9FE] flex flex-col overflow-hidden"
                >
                    <div className="bg-gradient-to-tr from-[#6DE3FD] via-[#ABE6FD] to-[#95B4F7] h-[88px] px-[14px] py-[4px] flex items-center justify-center">
                        <img className=" h-full object-cover" src="/imgs/sdwan/7.png" />
                    </div>
                    <div className="flex-1 px-[8px]">
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[12px] text-[#003366] mt-[14px]">
                            企业组网/私有化部署
                        </div>
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[10px] text-[rgba(0,51,102,0.6)] mt-[4px]">
                            跨国办公，直播引流和AI创作全都搞定，解决企业客户海外获客与客户建联时的各种痛点需求
                        </div>
                    </div>
                </div>



                <div
                    className="flex-1 bg-blue-500 bg-gradient-to-b from-[#D8E7FE] to-[#FFFFFF]
rounded-[20px] border border-[#DDE9FE] flex flex-col overflow-hidden"
                >
                    <div className=" bg-gradient-to-br from-[#6DA7FD] via-[#E2CDFF] to-[#BED3FF] h-[88px] px-[14px] py-[4px] flex items-center justify-center">
                        <img className=" h-full object-cover" src="/imgs/sdwan/8.png" />
                    </div>
                    <div className="flex-1 px-[8px] ">
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[12px] text-[#003366] mt-[14px]">
                            企业组网/私有化部署
                        </div>
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[10px] text-[rgba(0,51,102,0.6)] mt-[4px]">
                            跨国办公，直播引流和AI创作全都搞定，解决企业客户海外获客与客户建联时的各种痛点需求
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/**
 * 
 * @param props   <div
                    className="w-[27%] bg-blue-500 bg-gradient-to-b from-[#D8E7FE] to-[#FFFFFF]
        rounded-[20px] border border-[#DDE9FE] flex flex-col overflow-hidden"
                >
                    <div className="bg-gradient-to-tr from-[#6DE3FD] via-[#ABE6FD] to-[#95B4F7] h-[200px] px-[36px] py-[6px] flex items-center justify-center">
                        <img className=" h-full object-cover" src="/imgs/sdwan/7.png" />
                    </div>
                    <div className="flex-1 px-[20px]">
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[28px] text-[#003366] mt-[35px]">
                            企业组网/私有化部署
                        </div>
                        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[rgba(0,51,102,0.6)] mt-[10px]">
                            跨国办公，直播引流和AI创作全都搞定，解决企业客户海外获客与客户建联时的各种痛点需求
                        </div>
                    </div>
                </div>
 * @returns 
 */

/**
 * 
 * @param props    <div
    className="w-[27%] bg-blue-500 bg-gradient-to-b from-[#D8E7FE] to-[#FFFFFF]
rounded-[20px] border border-[#DDE9FE] flex flex-col overflow-hidden"
>
    <div className=" bg-gradient-to-br from-[#6DA7FD] via-[#E2CDFF] to-[#BED3FF] h-[200px] px-[36px] py-[6px] flex items-center justify-center">
        <img className=" h-full object-cover" src="/imgs/sdwan/8.png" />
    </div>
    <div className="flex-1 px-[20px]">
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[28px] text-[#003366] mt-[35px]">
            企业组网/私有化部署
        </div>
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[rgba(0,51,102,0.6)] mt-[10px]">
            跨国办公，直播引流和AI创作全都搞定，解决企业客户海外获客与客户建联时的各种痛点需求
        </div>
    </div>
</div>
 * @returns 
 */

export const Item = (props: { content: string }) => {
    const { content } = props;
    return (
        <div className="flex mt-[8px] items-center ">
            <div className="w-[10px] h-[10px]  rounded-full mr-[5px]">
                <svg viewBox="0 0 10.4544 10.4543" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="10.454407" height="10.454346" fill="none">
                    <rect id="Frame" width="10.454401" height="10.454401" x="0.000000" y="0.000000" fill="rgb(255,255,255)" fillOpacity="0" />
                    <path id="Vector" d="M0.00158691 5.23233C0.00158691 2.34547 2.34193 0.00512695 5.22879 0.00512695C8.11564 0.00512695 10.456 2.34547 10.456 5.23233C10.456 8.11918 8.11564 10.4595 5.22879 10.4595C2.34193 10.4595 0.00158691 8.11918 0.00158691 5.23233ZM4.28248 7.21938C4.34814 7.28709 4.43772 7.32637 4.532 7.32879C4.62629 7.33122 4.71776 7.2966 4.78682 7.23236L8.21226 4.04774C8.28176 3.98252 8.3226 3.89243 8.32586 3.79718C8.32912 3.70192 8.29453 3.60926 8.22964 3.53944C8.16476 3.46963 8.07487 3.42835 7.97964 3.42463C7.8844 3.42091 7.79157 3.45506 7.72144 3.51961L4.56547 6.47568L3.08383 4.9479C3.05098 4.91345 3.01163 4.88586 2.96806 4.8667C2.92449 4.84755 2.87756 4.83721 2.82997 4.83628C2.78238 4.83536 2.73508 4.84387 2.6908 4.86132C2.64652 4.87877 2.60613 4.90482 2.57197 4.93796C2.5378 4.9711 2.51054 5.01067 2.49175 5.05441C2.47296 5.09814 2.46302 5.14516 2.4625 5.19275C2.46197 5.24034 2.47088 5.28757 2.4887 5.3317C2.50653 5.37584 2.53291 5.416 2.56634 5.44989L4.28266 7.21938L4.28248 7.21938Z" fill="rgb(116,185,255)" fillRule="nonzero" />
                </svg>

            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[10px] text-[#003366]">
                {content}
            </div>
        </div>
    );
};